import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";
import { param } from "~/utils/url_helper";

//TODO test
export const useWorkloadEvents = (params, config) => {
  return useQuery({
    ...config,
    queryKey: ["workload-events", params],
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/workload/events?${param(params)}`,
        signal,
      }),
  });
};
